var cell_default = {
  "cell": "_4uQqq",
  "header": "sWXHd",
  "selected": "WZhuf",
  "editing": "SnoI2",
  "singleSelection": "ojuYr",
  "hideLastBlock": "ssnpc",
  "editorWrapper": "RgZvK",
  "viewerWrapper": "pr9bf",
  "hideFirstBlock": "hs8Xi",
  "editor": "v7Z4Q",
  "edit": "cqZJc",
  "view": "_7r4W5",
  "editingToolbarWrapper": "s3-ag",
  "selectAll": "RiwnX",
  "disableSelection": "KL7Oi"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
